import React, { Component } from 'react'
import CreateScriptDetail from './CreateScriptDetail'
import ViewScriptDetail from './ViewScriptDetail'
import setTitle from "../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../helpers/cookieHelper";
import { API_URL } from "../../constants";
import { isEmpty } from "../../helpers/index";

const axios = require("axios");

export default class ScriptDetail extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.formClear = this.formClear.bind(this);
    this.childRef = React.createRef();
    this.state = {
      user: {
        modulesDetail: "",
        tableName: "",
        type: "",
        script: "",
        // entrydate: new Date(),
        // createdby: getCookie("username"),
        status: ""
      },
      rules: {
        modulesDetail: ["required"],
        type: ["required"],
        status: ["required"],
      },
      type: [
        { value: "script", text: "Script" },
        { value: "data", text: "Data" },
      ],
      status: [
        { value: "fresh", text: "Fresh" },
        { value: "upgrade", text: "Upgrade" },
      ],
      operation: "Add",
      selected: {},
      permissions: [],

      //   scriptList: [],
    };
  }
  componentDidMount() {
    var data = getCookie("permission");
    this.setState(
      {
        permissions: JSON.parse(data),

      },
      function () {
        setTitle("Script Detail");

      }
    );
  }
  formClear() {
    let user = {
      modulesDetail: "",
      tableName: "",
      type: null,
      script: "",
      // entrydate: new Date(),
      // createdby: getCookie("username"),
      status: null
    };
    this.setState(
      {
        user: user,
        operation: "Add",
      },
      function () {
        this.childRef.current.validate((errors) => { });
      }
    );
  }
  OnEditClick() {
    var rules = this.state.rules;
    //console.log("this.state.selected", this.state.selected);
    if (this.state.selected != null) {
      this.setState({
        rules: rules,
        user: this.state.selected,
        operation: "Update",
      });

      const timer = setTimeout(() => {
        this.childRef.current.validate((errors) => { });
      }, 100);
      return () => clearTimeout(timer);
    }
  }
  onSelectionChange(selectedRow) {
    this.setState({
      selected: selectedRow,
    });
  }
  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user });
  }
  render() {
    const { permissions, isLoading } = this.state;
    return (
      <div>

        <div className='container-fluid'>
          <div className='row'>
            {permissions.includes("technical-access-create") ? (
              <div className='col-4'>
                <CreateScriptDetail
                  userFields={this.state.user}
                  //clientsList={this.state.clientsList}
                  type={this.state.type}
                  status={this.state.status}
                  validationRules={this.state.rules}
                  handleChange={this.handleChange}
                  operation={this.state.operation}
                  ref={this.childRef}
                  formClear={this.formClear}

                />
              </div>
            ) : null}
            {permissions.includes("technical-access-view") ? (
              <div className='col-8'>
                <ViewScriptDetail
                  selectedRow={this.state.selected}
                  OnEditClick={this.OnEditClick}
                  onSelectionChange={this.onSelectionChange}
                  permissions={permissions}
                  type={this.state.type}
                  status={this.state.status}
                />
              </div>) : null}
          </div>

        </div>
      </div>
    )
  }
}
